
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ApplicationService } from '@app/applications/application.service';
import { LoanApplication,ApplicationAccessSpecifier } from '@app/applications/applications.model';
import { SecureStorageService } from '@ig-core/authentication/secureStorage.service';

@Component({
  selector: 'eng-post-condition',
  templateUrl: 'post-condition.template.html',
  styleUrls: ['../../application-details.styles.scss', 'post-condition.style.css']
})
export class PostConditionComponent implements OnInit {

  @Input()
  application: LoanApplication;
  @Input()
  menuCode:string;

  postConditionsItems: any;
  postConditionForm: FormGroup

  allowAccess:Boolean;
  hideOrShowTrail:boolean=false;
  disableEdit:Boolean;
  menuItemAllowAccess:boolean;

  trailLabel:string='HIDE TRAIL';

  applicationAccessSpecifiers: ApplicationAccessSpecifier[];
  menuItemAccessSpecifier: ApplicationAccessSpecifier;
  loginUser: any;


  constructor(private applicationService: ApplicationService,
    private formBuilder: FormBuilder,
    private secureStorageService: SecureStorageService) {
      this.allowAccess = this.applicationService.allowAccess;
     }

  ngOnInit() {
    this.loginUser = this.secureStorageService.secureSessionStorage.getItem("logInUserDetails")
    this.getPostConditionItem()
    this.getMenuItemAccess();

  }

  getPostConditionItem() {
    this.applicationService.getPostConditions(this.application.uid).subscribe(response => {
      this.postConditionsItems = response.body
      if(this.postConditionsItems.state == "Approval"){
        this.disableEdit = true
        // this._snackbar.open("One or more conditions are not fulfilled yet. Return the application", "Close", {
        //   duration: 5000,
        // });
      }else{
        this.disableEdit = false
      }
      this.postConditionForm = this.formBuilder.group({
        //postConditionCompletedFlag: new FormArray(this.postConditionsItems.conditions.map(data => new FormControl(data.condition.completedFlag))),
        postConditionRemarks: new FormArray(this.postConditionsItems.conditions.map(data => new FormControl(data.condition.recommendRemarks))),
        postConditionRecommendFlag: new FormArray(this.postConditionsItems.conditions.map(data => new FormControl(data.condition.recommendFlag))),
      })
      this.postConditionForm.disable()
    })
  }

  savePostCondition() {
    if (this.postConditionForm.get('postConditionRecommendFlag')['controls'].length !== 0 && this.postConditionForm.get('postConditionRemarks')['controls'].length !== 0) {
      this.postConditionsItems.conditions.forEach((element, index) => {
        element.approvaltrail = []
        element.condition.recommendFlag = this.postConditionForm.get('postConditionRecommendFlag')['controls'][index].value
        element.condition.recommendRemarks = this.postConditionForm.get('postConditionRemarks')['controls'][index].value
      });
    }
    this.applicationService.savePostconditions(this.application.uid,
      this.postConditionsItems).subscribe((response: any) => {
        this.getPostConditionItem();
        this.postConditionForm.disable()
      });
  }

  enableDisableForm() {
    this.postConditionForm.enable()
  }

  cancelForm() {
    this.postConditionForm.disable()
    // this.postConditionForm.removeControl("postConditionRecommendFlag")
    // this.postConditionForm.removeControl("postConditionRemarks")
    this.postConditionForm = this.formBuilder.group({
      //postConditionCompletedFlag: new FormArray(this.postConditionsItems.conditions.map(data => new FormControl(data.condition.completedFlag))),
      postConditionRemarks: new FormArray(this.postConditionsItems.conditions.map(data => new FormControl(data.condition.recommendRemarks))),
      postConditionRecommendFlag: new FormArray(this.postConditionsItems.conditions.map(data => new FormControl(data.condition.recommendFlag))),
    })
    //this.postConditionForm.reset();
   
    this.postConditionForm.updateValueAndValidity()
  }

  hideOrShowTrailfunction(){
    this.hideOrShowTrail=!this.hideOrShowTrail
    if(this.hideOrShowTrail){
      this.trailLabel='SHOW TRAIL'
    }else{
      this.trailLabel='HIDE TRAIL'
    }
   
  }

  //this function will get either this menu item  is editable or readonly 
  getMenuItemAccess(){
    this.applicationService.getApplicationAccessModifiers(this.application.uid)
        .subscribe((response) => {
          this.applicationAccessSpecifiers = response.body;
          this.menuItemAccessSpecifier = this.applicationAccessSpecifiers
            .find(accessSpecifier => accessSpecifier.category === this.menuCode);
          if(this.menuItemAccessSpecifier){
          this.menuItemAllowAccess = this.menuItemAccessSpecifier.allowAccess;
            }
      });
    }

}




